import {COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import React, {ComponentProps} from 'react';

export const CouponExpiryDateCountdownIcon: React.FC<
  Omit<ComponentProps<typeof Icon>, 'asset'>
> = props => {
  return (
    <Icon
      asset={GenericIconName.Clock}
      size="S"
      fill={COLORS.PrimaryCoupon}
      {...props}
    />
  );
};
